import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useBody3Variant } from '€theme/theme';

interface DetailsReminderProps {
    subTitle: string;
    description: string;
}

const DetailsReminder: React.FunctionComponent<DetailsReminderProps> = ({
    subTitle,
    description,
}) => {
    const body3Classes = useBody3Variant();
    return (
        <Box>
            <Typography variant="h3" color="textPrimary">
                {subTitle}
            </Typography>
            <Box my={2}>
                <Typography variant="body2" classes={body3Classes} color="textSecondary">
                    {description}
                </Typography>
            </Box>
        </Box>
    );
};

export default DetailsReminder;
